<template>
    <div class="mb-1 flex items-center gap-1 py-1">
        <span :class="`country-flag-authority authority-position authority-position--${countryCode}`" class="shrink-0"></span>
        <span class="grow text-xs text-black">
            <template v-if="showParts.includes('name')">
                {{ t(`commonCountry.${countryCode}`) }}
            </template>
            <span v-if="showParts.includes('code')" class="text-grey-60">
                ({{ countryCode }})
            </span>
        </span>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { PropType } from 'vue';
import { messages } from './locales';

defineProps({
    countryCode: {
        type: String,
    },
    showParts: {
        type: Array as PropType<string[]>,
        default: () => ['name', 'code'],
    },
})

const { t } = useI18n(
    {
        messages,
    }
);

</script>
